
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductMasterLaborGrid extends Serenity.EntityGrid<ProductMasterLaborRow, any> {
        protected getColumnsKey() { return 'OMS.ProductMasterLabor'; }
        protected getIdProperty() { return ProductMasterLaborRow.idProperty; }
        protected getInsertPermission() { return ProductMasterLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductMasterLaborRow.localTextPrefix; }
        protected getService() { return ProductMasterLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}